import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Client } from "@hiveio/dhive";
import { css } from "@emotion/react";
import PacmanLoader from "react-spinners/PacmanLoader";
import NftCard from '../components/NftCard';
import { onHandleNFTBulkSellAction, onHandleNFTsellAction, onHandleNFTTransferAction } from './../utils/actions/nftMarketSell';
import { symbolList, symbolNft, symbolPack } from '../config/config';
import { Button, Modal, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { sendTxToBackend, transferNftAndListenChain, validateUsername } from '../utils/hiveLogic';
import { nap } from '../utils/generalUtils';
import { UnboxingMsg } from './UnboxingMsg';
import { triggerAlert } from '../utils/monitoring/triggerAlert';
import { AnonAdCorner } from '../components/Ads';
import { extractCategories, parseSchemaName } from '../utils/inventory/utils';
import './Home.scss';


const hiveClient = new Client('https://anyx.io');

//** css for spinner */
const override = css`
    display: block;
    margin: 30px auto;
    border-color: red;
`;


export const Home = () => {
    const isLocal = process.env.REACT_APP_ENV_MODE !== 'production';
    const fetchUrl = isLocal ? 'https://enginetestnet.rishipanthee.com/contracts' : 'https://engine.rishipanthee.com/contracts';
    let keychain = window.hive_keychain;

    // const apiEndpoint = process.env.REACT_APP_API_URL;
    const UserState = useSelector((store) => store.user);
    const [state, setState] = useState({
        price: "",
        currency: "BEE",
    });
    const [nftList, setNftList] = useState([]);
    const [loading, setLoading] = useState({ value: true, msg: '' });
    const [selectedNft, setSelectedNft] = useState([]);
    const [selTransferId, setSelTransferId] = useState("");
    
    // Searches
    const [searchNftName, setNftSearch] = useState('');
    const [searchUserName, setUserSearch] = useState('');
    const [searchedAccount, setSearchedAccount] = useState('');

    const [show, setShow] = useState(false);
    const [bulkShow, setBulkShow] = useState(false);
    const [validated, setValidated] = useState(false);
    const [validatedTran, setValidatedTran] = useState(false);
    const [offset, setOffset] = useState(0);

    const handleClose = () => setShow(false);
    const handleBulkSellShow = () => setShow(true);
    const handleBulkTransfterClose = () => {setBulkShow(false); setSelTransferId("")};
    const handleBulkTransfterShow = () => setBulkShow(true);
    
    const [currentNftSymbol, setCurrentNftSymbol] = useState(symbolNft);
    
    const toggleSingleAndPacks = (type) => {
        setLoading({ value: true });
        switch (type) {
            case 'pack': {
              setCurrentNftSymbol(symbolPack);
              setNftList([]);
              setOffset(0);
              break;
            }
            case 'single': {
              setCurrentNftSymbol(symbolNft);
              setNftList([]);
              setOffset(0);
              break;
            }
            default: { console.error('Unexpected type in NFT toggle:', type); }
        }
    };

    const fetchNftList = async ({ givenUsername = '' } = {}) => {
        setLoading({ value: true });
        return axios.post(fetchUrl, [{
            method: "find",
            jsonrpc: "2.0",
            params: {
                contract: "nft",
                table: `${currentNftSymbol}instances`, // `${symbolNft}instances`,
                query: { account: givenUsername || UserState.username },
                limit: 1000,
                offset: offset,
                indexes: []
            },
            id: 1
        }]).then((res) => {
            console.debug('NFTs for', currentNftSymbol, res.data);
            return res.data;
          })
            .catch(err => console.error('Caught error fetching NFT list:', err))
            .finally(() => setLoading({ value: false }));

    }

    useEffect(() => {
      (async function fetchData() {
        console.log('page loaded, fetching nfts');
        // let data = await hiveClient.database.getAccounts([UserState.username]);
        // console.log('hive user data:', UserState.username, data);
        let res = await fetchNftList();
        setNftList(res[0]?.result || []);
      })();
    }, [currentNftSymbol, offset]);

    const searchUserNfts = async () => {
      const givenUsername = searchUserName.replace('@', '');
      console.log('loading nfts for', givenUsername);
      const { err } = await validateUsername({ username: givenUsername });
      if (err) {
        alert(`Incorrect account. Error: ${err}`);
        return;
      }
      let res = await fetchNftList({ givenUsername });
      setNftList(res[0]?.result || []);
      setSearchedAccount(givenUsername);
    };

    const resetUserNfts = async () => {
      setUserSearch('');
      let res = await fetchNftList();
      setNftList(res[0]?.result || []);
      setSearchedAccount('');
    };


    const handleChange = (e) => {
        const {name, value} = e.target;
        setState({
            ...state,
            [name]: value,
        })
    }

    const handleCheck = (id, checked) => {
        let selected = selectedNft;
        selected = selected.filter(sel => sel !== id);
        if(checked) {
            selected.push(id);
        }
        setSelectedNft(selected);
    }

    const handleTransfer = (nftId) => {
        setSelTransferId(nftId);
        console.log("nftId to transfer: ", nftId);
        handleBulkTransfterShow();
    }

    const handleTransferSubmit = async (event) => {
        console.log("bulk transfter");
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidatedTran(true);
        } else {
          let selNFTs = selectedNft;
          if(selTransferId) {
              selNFTs = [selTransferId];
          }
          const { err } = await validateUsername({ username: state.transfterToUser });
          if (err) {
            alert(`Incorrect username: ${err}`);
            return;
          }
          await onHandleNFTTransferAction(keychain, UserState.username, selNFTs, state.transfterToUser, currentNftSymbol);
          setSelTransferId("");
          handleBulkTransfterClose();
        }
    }

    const handleUnboxing = async (nftId) => {
        setLoading({
          value: true,
          msg: <UnboxingMsg status={'init'}/>,
        });
        const { err: errTransfer, skipNotify, tx, block, seconds } = await transferNftAndListenChain({ nftId, user: UserState.username });
        if (errTransfer) {
          !skipNotify && triggerAlert({ type: 'transf', nftId, user: UserState.username, err: errTransfer, tx, block, seconds });
          setLoading({
            value: true,
            msg: <UnboxingMsg
                status={'errorTransferAndScan'}
                {...{ tx, user: UserState.username, setLoading, errTransfer, nftId }}
              />,
            hidePacman: true,
          });
          return;
        }
        const { err: errBackend } = await sendTxToBackend({ user: UserState.username, tx, block });
        if (errBackend) {
          triggerAlert({ type: 'backend', nftId, user: UserState.username, err: errBackend, tx, block, seconds });
          setLoading({
            value: true,
            msg: <UnboxingMsg
                status={'errorClaim'}
                {...{ tx, user:UserState.username, setLoading, errTransfer, nftId }}
              />,
            hidePacman: true,
          });
          return;
        }
        setLoading({
          value: true,
          msg: <UnboxingMsg
              status={'success'}
              {...{ tx, user:UserState.username, seconds  }}
            />,
          hidePacman: true,
        });
        await nap(10 * 1000);
        setLoading({ value: false });
        toggleSingleAndPacks('single');
    };

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
             event.stopPropagation();
             setValidated(true);
        } else {
            await onHandleNFTBulkSellAction(keychain, UserState.username, selectedNft, state.price, state.currency, currentNftSymbol);
            handleClose();
        }
    };

    const isPacksView = currentNftSymbol === symbolPack;
    const isSingNftsView = currentNftSymbol === symbolNft;

    const handleSearchSubmit = async (event) => {
      event.preventDefault();
      searchUserNfts();
    };

    return (
        <div className="container home">
            <div className="row">
                <div className="col-12" id="section-title">
                    <h3 className='text-white' style={{ fontSize: '32px', marginBottom: '75px', marginTop: '-20px', fontWeight: 'bolder' }}>
                        {searchedAccount
                          ? <>
                              <a
                                href={`https://peakd.com/@${searchedAccount}`}
                                id="profile-link"
                                target="_blank" rel="noreferrer">@{searchedAccount}
                              </a>'s
                            </>
                          : 'MY'} NFTs
                    </h3>
                </div>

                <div className="col-12 row navbar">
                    <div className="col-4">
                        <button
                            style={{ float: 'left', marginLeft: '-10px' }}
                            className={`nft-type-choice-btn${isSingNftsView ? ' disabled' : ''}`}
                            onClick={() => toggleSingleAndPacks('single')}
                            disabled={isSingNftsView}
                        >
                            ITEMS
                        </button>
                        <button
                            style={{ float: 'left', marginLeft: '15px' }}
                            className={`nft-type-choice-btn${isPacksView ? ' disabled' : ''}`}
                            onClick={() => toggleSingleAndPacks('pack')}
                            disabled={isPacksView}
                        >
                            PACKs
                        </button>
                    </div>

                    <div className="col-3 row" style={{ marginTop: '-40px' }}>
                        <form className="row" id="username-search" onSubmit={handleSearchSubmit}>
                          <div className="col-9">
                            <input
                              className='form-control'
                              style={{ marginBottom: '15px', display: 'inline-block' }}
                              placeholder='Another account'
                              value={searchUserName}
                              onChange={(e) => setUserSearch(e.target.value)}
                            />
                          </div>
                          <div className="col-2">
                            <button type="submit"></button>
                          </div>
                          <div className="col-1">
                            {searchUserName && <button id="reset-search" onClick={resetUserNfts}></button>}
                          </div>
                        </form>

                        <input
                          className='form-control'
                          placeholder='Search by NFT name'
                          value={searchNftName}
                          onChange={(e) => setNftSearch(e.target.value)}
                        />
                    </div>
                
                    <div className="col-2"></div>
                    <div className="col-3" style={{ textAlign: 'right' }}>
                        <Button variant="primary" className='mb-2 mr-2' onClick={handleBulkTransfterShow} disabled={selectedNft.length === 0}>Bulk Transfer</Button>
                        <Button variant="primary" className='mb-2' onClick={handleBulkSellShow} disabled={selectedNft.length === 0}>Bulk Sell</Button>
                    </div>
                </div>

                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                    <Modal.Title>Sell Nfts</Modal.Title>
                    </Modal.Header>
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <Modal.Body>
                            <Form.Group className="mb-3" controlId="formPrice">
                                <Form.Label>Price</Form.Label>
                                <Form.Control type="number" name='price' onChange={handleChange} value={state.price} placeholder="Enter price..." min={0} required />
                                <Form.Control.Feedback type="invalid">
                                    Please set the price correctly.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formCurrency">
                                <Form.Label>Currency</Form.Label>
                                <Form.Select aria-label="Default select example"  name='currency' onChange={handleChange} value={state.currency} >
                                    {symbolList.map((sym, index) => <option value={sym} key={index}>{sym}</option>)}
                                </Form.Select>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button type='button' variant="danger" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="primary">
                            Submit
                        </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                <Modal show={bulkShow} onHide={handleBulkTransfterClose}>
                    <Modal.Header closeButton>
                    <Modal.Title>{selTransferId ? "" : ''/*"Bulk"*/} Transfer <b>{selectedNft.length || 1}</b> NFT{selTransferId ? "" : "s"}</Modal.Title>
                    </Modal.Header>
                        <Form noValidate validated={validatedTran} onSubmit={handleTransferSubmit}>
                            <Modal.Body>
                            <Form.Group className="mb-3" controlId="formTransterUser">
                                <Form.Label>Username</Form.Label>
                                <Form.Control name='transfterToUser' onChange={handleChange} value={state.transfterToUser} placeholder="Enter username..." required />
                                <Form.Control.Feedback type="invalid">
                                    Please input the username.
                                </Form.Control.Feedback>
                            </Form.Group>
                            {/* <Form.Group className="mb-3" controlId="formCurrency">
                                <Form.Label>Currency</Form.Label>
                                <Form.Select aria-label="Default select example"  name='currency' onChange={handleChange} value={state.currency} >
                                    {symbolList.map((sym, index) => <option value={sym} key={index}>{sym}</option>)}
                                </Form.Select>
                            </Form.Group> */}
                            </Modal.Body>
                            <Modal.Footer>
                            <Button type='button' variant="danger" onClick={handleBulkTransfterClose}>
                                Cancel
                            </Button>
                            <Button type="submit" variant="primary">
                                Submit
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {(nftList.length >= 1000 || offset >= 1000) && <div id="home-pagination" className="text-white">
                    <button
                      onClick={() => setOffset(0)}
                      disabled={offset === 0}>
                        Page 1
                    </button>
                    <button
                      onClick={() => setOffset(1000)}
                      disabled={offset === 1000}
                    >
                        Page 2
                    </button>
                    {offset >= 1000 && <button
                      onClick={() => setOffset(2000)}
                      disabled={offset === 2000 || nftList.length < 1000}>
                        Page 3
                    </button>}
                    {offset >= 2000 && <button
                      onClick={() => setOffset(3000)}
                      disabled={offset === 3000 || nftList.length < 1000}>
                        Page 4
                    </button>}
                </div>}
                {loading.value && <div className="col-12">
                    {!loading.hidePacman
                      && <div className="pacman">
                          <PacmanLoader color={"#fff"} loading={loading.value} css={override} size={25} margin={2}/>
                        </div>
                    }
                    {loading.msg}
                </div>}

                {(!loading.value && nftList.length > 0)
                      && <div id="tab-wrapper">
                           <div className="row">
                              <AllYourFilteredNFTsInventory
                                nftList={nftList}
                                searches={{ searchedAccount, searchNftName }}
                                actions={{ onHandleNFTsellAction, handleTransfer, handleCheck, handleUnboxing }}
                                otherState={{ currentNftSymbol, selectedNft }}
                              />
                          </div>
                        </div>
                }
                {(!loading.value && !nftList.length) && <div className='col-12 no-nfts'>
                    <h5>There are no {currentNftSymbol === symbolPack ? 'NFT Packs' : 'Gaming NFTs'} here.</h5>
                    <br/>
                    <div className="empty-push-sale">
                      <p>Buy some from other users <Link to='/marketplace'>here</Link>.</p>
                      <p>Or if you listed yours on the market, they're <Link to='/marketplace'>here</Link>.</p>
                    </div>
                  </div>
                }
            </div>
            
            <AnonAdCorner />
        </div>
    );
};


const AllYourFilteredNFTsInventory = ({ nftList, searches, actions, otherState }) => {
  const { searchedAccount, searchNftName } = searches;
  const { onHandleNFTsellAction, handleTransfer, handleCheck, handleUnboxing } = actions;
  const { currentNftSymbol, selectedNft } = otherState;

  const [collapsed, setCollapsed] = useState([]);

  const handleCollapse = (category) => {
    if (!collapsed.includes(category)) setCollapsed([...collapsed, category]);
    else setCollapsed([...collapsed.filter(cat => cat !== category)]);
  };

  const foundCategories = extractCategories({ hiveNfts: nftList });
  const filteredList = nftList.filter(
    nft => nft.properties.name
      && nft.properties.name.toLowerCase().includes(searchNftName.toLowerCase()),
  );

  const PageElements = ({ categoryItems }) => <p>
      {categoryItems
        .sort((aa, bb) => (aa.properties.name > bb.properties.name)
          || (parseFloat(aa?._id) - parseFloat(bb?._id)))
        .map(
          (nft, index) =>
            <div className="col-3 align-left categorized-items" key={index}>
                <NftCard
                  nft={nft}
                  action={(price, priceSymbol) => onHandleNFTsellAction(window.hive_keychain, nft, price, priceSymbol, currentNftSymbol)}
                  actionType="Sell"
                  checked={selectedNft.findIndex(sel => sel === nft._id) >= 0}
                  handleTransfer={handleTransfer}
                  handleCheck={handleCheck}
                  handleUnboxing={handleUnboxing}
                  isPack={currentNftSymbol === symbolPack}
                  hideButtons={!!searchedAccount}
                />
            </div>
        )
      }
  </p>;

  const CategorizedItems = ({ category }) => {
    const categoryItems = filteredList.filter(({ properties }) => properties.schema === category);
    return (
      <>
        <div
          className="category-name col-12 row"
          style={{ paddingLeft: '30px' }}
          onClick={() => handleCollapse(category)}
        >
          <div className="col-3">
            {parseSchemaName(category)}
          </div>
          <div className="col-8 category-count">[ {categoryItems.length} items ]</div>
          <div className="col-1">
            <img
              className={!collapsed.includes(category) ? 'flipped' : ''}
              src="https://cdn3.iconfinder.com/data/icons/neutro-interface/32/previous-64.png"
              width="20" alt="collapse"
            />
          </div>
        </div>
        {collapsed.includes(category)
          ? <></>
          : <PageElements {...{ categoryItems }} />
        }
      </>
    );
  };

  return (
    <>
      {foundCategories
        .reverse()
        .map(category => <CategorizedItems category={category} />)}
    </>
  );
};
